export default "__VITE_ASSET__8aa3ed8c__"